
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    const logo = require('@/assets/logo.png')

    return {
      logo
    }
  },
  props: {
    collapse: {
      type: Boolean
    }
  }
})
